
const BUILD_TARGET = {
  LOCALHOST: 'localhost',
  NNBOX_DEV: 'dev',
  NNBOX_STAGE: 'stage',
  NNBOX_QA02: 'qa02',
  NNBOX_QA03: 'qa03',
  NNBOX_LIVE_SN: 'sn', // 성남
  NNBOX_LIVE_YJ: 'yj', // 영종
  NNBOX_LIVE_GY: 'gy', // 덕양
  NNBOX_LIVE_GP: 'gp', // 김포
  GOGOIT_QA02: 'gogoit_qa02',
  GOGOIT_QA03: 'gogoit_qa03',
  GOGOIT_LIVE_GY: 'gogoit_gy',
  GOGOIT_LIVE_GP: 'gogoit_gp',
};
Object.freeze(BUILD_TARGET);

const getTargetInfo = (buildTarget) => {
  switch (buildTarget) {
    case BUILD_TARGET.LOCALHOST: {
      return {
        skinType: "NNBOX",
        serverProtocol: "http",
        serverIp: "127.0.0.1",
        serverPort: "30001",
        wsProtocol: "ws",
        wsHost: "127.0.0.1",
        wsPath: '/ws/nnbox',
        wsPort: "30001",
        cloudFlareOrderInfoHost: "nnbox-fr-cust-service-staging.sbinc-nyamnyambox.workers.dev",
        cloudFlareOrderAwaitHost: "nnbox-order-await-service-staging.sbinc-nyamnyambox.workers.dev",
        yUrl: "https://nnbox-yang-staging.sbinc-nyamnyambox.workers.dev",
        yBearerToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC15YW5nIiwibmFtZSI6ImhlZXdvb2siLCJpYXQiOjE4OTM0MjM2MDB9.YJ6GRW6s1YjNSAXLtbOT3p8C21fjcIg1vYEjIK8cBeU",
        yLogUrl: "https://nnbox-log-service-staging.sbinc-nyamnyambox.workers.dev",
        yLogBearerToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJubmxvZyI6ImxpdmUifQ.bLr-YxVD2-M-TUblNmaUskKguyenW1WZpuSwtreKXGc",
        yogiyoUrl: "https://crs.rpsyogiyo.io/api",
        yWebsockUrl: "nnbox-ws.nyamnyambox.com/ws",
        allServerIp: ["127.0.0.1", "127.0.0.1", "127.0.0.1", "127.0.0.1"],
      };
    }
    case BUILD_TARGET.NNBOX_DEV: {
      return {
        skinType: "NNBOX",
        serverProtocol: "http",
        serverIp: "127.0.0.1",
        serverPort: "30001",
        wsProtocol: "ws",
        wsHost: "127.0.0.1",
        wsPath: '/ws/nnbox',
        wsPort: "30001",
        cloudFlareOrderInfoHost: "nnbox-fr-cust-service-staging.sbinc-nyamnyambox.workers.dev",
        cloudFlareOrderAwaitHost: "nnbox-order-await-service-staging.sbinc-nyamnyambox.workers.dev",
        yUrl: "https://nnbox-yang-staging.sbinc-nyamnyambox.workers.dev",
        yBearerToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC15YW5nIiwibmFtZSI6ImhlZXdvb2siLCJpYXQiOjE4OTM0MjM2MDB9.YJ6GRW6s1YjNSAXLtbOT3p8C21fjcIg1vYEjIK8cBeU",
        yLogUrl: "https://nnbox-log-service-staging.sbinc-nyamnyambox.workers.dev",
        yLogBearerToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJubmxvZyI6ImxpdmUifQ.bLr-YxVD2-M-TUblNmaUskKguyenW1WZpuSwtreKXGc",
        yogiyoUrl: "https://crs.rpsyogiyo.io/api",
        yWebsockUrl: "nnbox-ws.nyamnyambox.com/ws",
        allServerIp: ["127.0.0.1", "127.0.0.1", "127.0.0.1", "127.0.0.1"],
      };
    }
    case BUILD_TARGET.NNBOX_STAGE: {
      return {
        skinType: 'NNBOX',
        serverProtocol: 'https',
        serverIp: 'nnstage.nnbox.net',
        serverPort: '30001',
        wsProtocol: 'wss',
        wsHost: 'nnstage.nnbox.net',
        wsPath: '/ws/nnbox',
        wsPort: '30001',
        cloudFlareOrderInfoHost: "nnbox-fr-cust-service-staging.sbinc-nyamnyambox.workers.dev",
        cloudFlareOrderAwaitHost: "nnbox-order-await-service-staging.sbinc-nyamnyambox.workers.dev",
        yUrl: "https://nnbox-yang-staging.sbinc-nyamnyambox.workers.dev",
        yBearerToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC15YW5nIiwibmFtZSI6ImhlZXdvb2siLCJpYXQiOjE4OTM0MjM2MDB9.YJ6GRW6s1YjNSAXLtbOT3p8C21fjcIg1vYEjIK8cBeU",
        yLogUrl: "https://nnbox-log-service-staging.sbinc-nyamnyambox.workers.dev",
        yLogBearerToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJubmxvZyI6ImxpdmUifQ.bLr-YxVD2-M-TUblNmaUskKguyenW1WZpuSwtreKXGc",
        yogiyoUrl: "https://crs.rpsyogiyo.io/api",
        yWebsockUrl: "ps.rpsyogiyo.io",
        allServerIp: ['nnstage.nnbox.net', 'qa02nadia.nyamnyambox.com'],
      };
    }
    case BUILD_TARGET.NNBOX_QA02: {
      return {
        skinType: 'NNBOX',
        serverProtocol: 'https',
        serverIp: 'qa02nadia.nyamnyambox.com',
        serverPort: '443',
        wsProtocol: 'wss',
        wsHost: 'qa02nadia.nyamnyambox.com',
        wsPath: '/ws/nnbox',
        wsPort: '443',
        cloudFlareOrderInfoHost: "nnbox-fr-cust-service-staging.sbinc-nyamnyambox.workers.dev",
        cloudFlareOrderAwaitHost: "nnbox-order-await-service-staging.sbinc-nyamnyambox.workers.dev",
        yUrl: "https://nnbox-yang-staging.sbinc-nyamnyambox.workers.dev",
        yBearerToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC15YW5nIiwibmFtZSI6ImhlZXdvb2siLCJpYXQiOjE4OTM0MjM2MDB9.YJ6GRW6s1YjNSAXLtbOT3p8C21fjcIg1vYEjIK8cBeU",
        yLogUrl: "https://nnbox-log-service-staging.sbinc-nyamnyambox.workers.dev",
        yLogBearerToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJubmxvZyI6ImxpdmUifQ.bLr-YxVD2-M-TUblNmaUskKguyenW1WZpuSwtreKXGc",
        yogiyoUrl: "https://crs.rpsyogiyo.io/api",
        yWebsockUrl: "ps.rpsyogiyo.io",
        allServerIp: ['nnstage.nnbox.net', 'qa02nadia.nyamnyambox.com'],
      };
    }
    case BUILD_TARGET.NNBOX_QA03: {
      return {
        skinType: 'NNBOX',
        serverProtocol: 'https',
        serverIp: 'qa03nadia.nyamnyambox.com',
        serverPort: '443',
        wsProtocol: 'wss',
        wsHost: 'qa03nadia.nyamnyambox.com',
        wsPath: '/ws/nnbox',
        wsPort: '443',
        cloudFlareOrderInfoHost: "nnbox-fr-cust-service-staging.sbinc-nyamnyambox.workers.dev",
        cloudFlareOrderAwaitHost: "nnbox-order-await-service-staging.sbinc-nyamnyambox.workers.dev",
        yUrl: "https://nnbox-yang-staging.sbinc-nyamnyambox.workers.dev",
        yBearerToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC15YW5nIiwibmFtZSI6ImhlZXdvb2siLCJpYXQiOjE4OTM0MjM2MDB9.YJ6GRW6s1YjNSAXLtbOT3p8C21fjcIg1vYEjIK8cBeU",
        yLogUrl: "https://nnbox-log-service-staging.sbinc-nyamnyambox.workers.dev",
        yLogBearerToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJubmxvZyI6ImxpdmUifQ.bLr-YxVD2-M-TUblNmaUskKguyenW1WZpuSwtreKXGc",
        yogiyoUrl: "https://crs.rpsyogiyo.io/api",
        yWebsockUrl: "ps.rpsyogiyo.io",
        allServerIp:['nnstage.nnbox.net', 'qa03nadia.nyamnyambox.com'],
      };
    }
    case BUILD_TARGET.NNBOX_LIVE_SN: {
      return {
        skinType: 'NNBOX',
        serverProtocol: 'https',
        serverIp: 'snnadia.nyamnyambox.com',
        serverPort: '443',
        wsProtocol: 'wss',
        wsHost: 'snnadia.nyamnyambox.com',
        wsPath: '/ws/nnbox',
        wsPort: '443',
        cloudFlareOrderInfoHost: 'frcust.nyamnyambox.com',
        cloudFlareOrderAwaitHost: "nnbox-order-await-service.sbinc-nyamnyambox.workers.dev",
        yUrl: 'https://y.nyamnyambox.com',
        yBearerToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC15YW5nIiwibmFtZSI6ImhlZXdvb2siLCJpYXQiOjE4OTM0MjM2MDB9.YJ6GRW6s1YjNSAXLtbOT3p8C21fjcIg1vYEjIK8cBeU',
        yLogUrl: 'https://nnbox-log.nyamnyambox.com',
        yLogBearerToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJubmxvZyI6ImxpdmUifQ.bLr-YxVD2-M-TUblNmaUskKguyenW1WZpuSwtreKXGc',
        yogiyoUrl: 'https://crs.rpsyogiyo.io/api',
        yWebsockUrl: 'ps.rpsyogiyo.io',
        allServerIp: ['snnadia.nyamnyambox.com', 'yjnadia.nyamnyambox.com', 'gynadia.nyamnyambox.com', 'nadia.nyamnyambox.com'],
      };
    }
    case BUILD_TARGET.NNBOX_LIVE_YJ: {
      return {
        skinType: 'NNBOX',
        serverProtocol: 'https',
        serverIp: 'yjnadia.nyamnyambox.com',
        serverPort: '443',
        wsProtocol: 'wss',
        wsHost: 'yjnadia.nyamnyambox.com',
        wsPath: '/ws/nnbox',
        wsPort: '443',
        cloudFlareOrderInfoHost: 'frcust.nyamnyambox.com',
        cloudFlareOrderAwaitHost: "nnbox-order-await-service.sbinc-nyamnyambox.workers.dev",
        yUrl: 'https://y.nyamnyambox.com',
        yBearerToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC15YW5nIiwibmFtZSI6ImhlZXdvb2siLCJpYXQiOjE4OTM0MjM2MDB9.YJ6GRW6s1YjNSAXLtbOT3p8C21fjcIg1vYEjIK8cBeU',
        yLogUrl: 'https://nnbox-log.nyamnyambox.com',
        yLogBearerToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJubmxvZyI6ImxpdmUifQ.bLr-YxVD2-M-TUblNmaUskKguyenW1WZpuSwtreKXGc',
        yogiyoUrl: 'https://crs.rpsyogiyo.io/api',
        yWebsockUrl: 'ps.rpsyogiyo.io',
        allServerIp: ['snnadia.nyamnyambox.com', 'yjnadia.nyamnyambox.com', 'gynadia.nyamnyambox.com', 'nadia.nyamnyambox.com'],
      };
    }
    case BUILD_TARGET.NNBOX_LIVE_GY: {
      return {
        skinType: 'NNBOX',
        serverProtocol: 'https',
        serverIp: 'gynadia.nyamnyambox.com',
        serverPort: '443',
        wsProtocol: 'wss',
        wsHost: 'gynadia.nyamnyambox.com',
        wsPath: '/ws/nnbox',
        wsPort: '443',
        cloudFlareOrderInfoHost: 'frcust.nyamnyambox.com',
        cloudFlareOrderAwaitHost: "nnbox-order-await-service.sbinc-nyamnyambox.workers.dev",
        yUrl: 'https://y.nyamnyambox.com',
        yBearerToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC15YW5nIiwibmFtZSI6ImhlZXdvb2siLCJpYXQiOjE4OTM0MjM2MDB9.YJ6GRW6s1YjNSAXLtbOT3p8C21fjcIg1vYEjIK8cBeU',
        yLogUrl: 'https://nnbox-log.nyamnyambox.com',
        yLogBearerToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJubmxvZyI6ImxpdmUifQ.bLr-YxVD2-M-TUblNmaUskKguyenW1WZpuSwtreKXGc',
        yogiyoUrl: 'https://crs.rpsyogiyo.io/api',
        yWebsockUrl: 'ps.rpsyogiyo.io',
        allServerIp: ['snnadia.nyamnyambox.com', 'yjnadia.nyamnyambox.com', 'gynadia.nyamnyambox.com', 'nadia.nyamnyambox.com'],
      };
    }
    case BUILD_TARGET.NNBOX_LIVE_GP: {
      return {
        skinType: 'NNBOX',
        serverProtocol: 'https',
        serverIp: 'nadia.nyamnyambox.com',
        serverPort: '443',
        wsProtocol: 'wss',
        wsHost: 'nadia.nyamnyambox.com',
        wsPath: '/ws/nnbox',
        wsPort: '443',
        cloudFlareOrderInfoHost: 'frcust.nyamnyambox.com',
        cloudFlareOrderAwaitHost: "nnbox-order-await-service.sbinc-nyamnyambox.workers.dev",
        yUrl: 'https://y.nyamnyambox.com',
        yBearerToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC15YW5nIiwibmFtZSI6ImhlZXdvb2siLCJpYXQiOjE4OTM0MjM2MDB9.YJ6GRW6s1YjNSAXLtbOT3p8C21fjcIg1vYEjIK8cBeU',
        yLogUrl: 'https://nnbox-log.nyamnyambox.com',
        yLogBearerToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJubmxvZyI6ImxpdmUifQ.bLr-YxVD2-M-TUblNmaUskKguyenW1WZpuSwtreKXGc',
        yogiyoUrl: 'https://crs.rpsyogiyo.io/api',
        yWebsockUrl: 'ps.rpsyogiyo.io',
        allServerIp: ['snnadia.nyamnyambox.com', 'yjnadia.nyamnyambox.com', 'gynadia.nyamnyambox.com', 'nadia.nyamnyambox.com'],
      };
    }
    case BUILD_TARGET.GOGOIT_QA02: {
      return {
        skinType: 'GOGOIT',
        serverProtocol: 'https',
        serverIp: 'qa02nadia.gogoit.io',
        serverPort: '443',
        wsProtocol: 'wss',
        wsHost: 'qa02nadia.gogoit.io',
        wsPath: '/ws/nnbox',
        wsPort: '443',
        cloudFlareOrderInfoHost: 'nnbox-fr-cust-service-staging.sbinc-nyamnyambox.workers.dev',
        cloudFlareOrderAwaitHost: "nnbox-order-await-service-staging.sbinc-nyamnyambox.workers.dev",
        yUrl: 'https://nnbox-yang-staging.sbinc-nyamnyambox.workers.dev',
        yBearerToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC15YW5nIiwibmFtZSI6ImhlZXdvb2siLCJpYXQiOjE4OTM0MjM2MDB9.YJ6GRW6s1YjNSAXLtbOT3p8C21fjcIg1vYEjIK8cBeU',
        yLogUrl: 'https://nnbox-log-service-staging.sbinc-nyamnyambox.workers.dev',
        yLogBearerToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJubmxvZyI6ImxpdmUifQ.bLr-YxVD2-M-TUblNmaUskKguyenW1WZpuSwtreKXGc',
        yogiyoUrl: 'https://crs.rpsyogiyo.io/api',
        yWebsockUrl: 'ps.rpsyogiyo.io',
        allServerIp: ['nnstage.nnbox.net', 'qa03nadia.gogoit.io'],
      };
    }
    case BUILD_TARGET.GOGOIT_QA03: {
      return {
        skinType: 'GOGOIT',
        serverProtocol: 'https',
        serverIp: 'qa03nadia.gogoit.io',
        serverPort: '443',
        wsProtocol: 'wss',
        wsHost: 'qa03nadia.gogoit.io',
        wsPath: '/ws/nnbox',
        wsPort: '443',
        cloudFlareOrderInfoHost: 'nnbox-fr-cust-service-staging.sbinc-nyamnyambox.workers.dev',
        cloudFlareOrderAwaitHost: "nnbox-order-await-service-staging.sbinc-nyamnyambox.workers.dev",
        yUrl: 'https://nnbox-yang-staging.sbinc-nyamnyambox.workers.dev',
        yBearerToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC15YW5nIiwibmFtZSI6ImhlZXdvb2siLCJpYXQiOjE4OTM0MjM2MDB9.YJ6GRW6s1YjNSAXLtbOT3p8C21fjcIg1vYEjIK8cBeU',
        yLogUrl: 'https://nnbox-log-service-staging.sbinc-nyamnyambox.workers.dev',
        yLogBearerToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJubmxvZyI6ImxpdmUifQ.bLr-YxVD2-M-TUblNmaUskKguyenW1WZpuSwtreKXGc',
        yogiyoUrl: 'https://crs.rpsyogiyo.io/api',
        yWebsockUrl: 'ps.rpsyogiyo.io',
        allServerIp: ['nnstage.nnbox.net', 'qa03nadia.gogoit.io'],
      };
    }
    case BUILD_TARGET.GOGOIT_LIVE_GY: {
      return {
        skinType: 'GOGOIT',
        serverProtocol: 'https',
        serverIp: 'gynadia.gogoit.io',
        serverPort: '443',
        wsProtocol: 'wss',
        wsHost: 'gynadia.gogoit.io',
        wsPath: '/ws/nnbox',
        wsPort: '443',
        cloudFlareOrderInfoHost: 'frcust.nyamnyambox.com',
        cloudFlareOrderAwaitHost: "nnbox-order-await-service.sbinc-nyamnyambox.workers.dev",
        yUrl: 'https://y.nyamnyambox.com',
        yBearerToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC15YW5nIiwibmFtZSI6ImhlZXdvb2siLCJpYXQiOjE4OTM0MjM2MDB9.YJ6GRW6s1YjNSAXLtbOT3p8C21fjcIg1vYEjIK8cBeU',
        yLogUrl: 'https://nnbox-log.nyamnyambox.com',
        yLogBearerToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJubmxvZyI6ImxpdmUifQ.bLr-YxVD2-M-TUblNmaUskKguyenW1WZpuSwtreKXGc',
        yogiyoUrl: 'https://crs.rpsyogiyo.io/api',
        yWebsockUrl: 'ps.rpsyogiyo.io',
        allServerIp: ['nadia.gogoit.io'],
      };
    }
    case BUILD_TARGET.GOGOIT_LIVE_GP: {
      return {
        skinType: 'GOGOIT',
        serverProtocol: 'https',
        serverIp: 'nadia.gogoit.io',
        serverPort: '443',
        wsProtocol: 'wss',
        wsHost: 'nadia.gogoit.io',
        wsPath: '/ws/nnbox',
        wsPort: '443',
        cloudFlareOrderInfoHost: 'frcust.nyamnyambox.com',
        cloudFlareOrderAwaitHost: "nnbox-order-await-service.sbinc-nyamnyambox.workers.dev",
        yUrl: 'https://y.nyamnyambox.com',
        yBearerToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC15YW5nIiwibmFtZSI6ImhlZXdvb2siLCJpYXQiOjE4OTM0MjM2MDB9.YJ6GRW6s1YjNSAXLtbOT3p8C21fjcIg1vYEjIK8cBeU',
        yLogUrl: 'https://nnbox-log.nyamnyambox.com',
        yLogBearerToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJubmxvZyI6ImxpdmUifQ.bLr-YxVD2-M-TUblNmaUskKguyenW1WZpuSwtreKXGc',
        yogiyoUrl: 'https://crs.rpsyogiyo.io/api',
        yWebsockUrl: 'ps.rpsyogiyo.io',
        allServerIp: ['nadia.gogoit.io'],
      };
    }
    default:
      return undefined;
  }
};

const buildTargetInfo = getTargetInfo(BUILD_TARGET.NNBOX_LIVE_GY);

export default {
  appName: 'nnboxFranchise',
  clientMinorVersion: 'v24061712',

  skinType: buildTargetInfo.skinType,

  serverProtocol: buildTargetInfo.serverProtocol,
  serverIp: buildTargetInfo.serverIp,
  serverPort: buildTargetInfo.serverPort,
  wsProtocol: buildTargetInfo.wsProtocol,
  wsHost: buildTargetInfo.wsHost,
  wsPath: buildTargetInfo.wsPath,
  wsPort: buildTargetInfo.wsPort,
  cloudFlareOrderInfoHost: buildTargetInfo.cloudFlareOrderInfoHost,
  cloudFlareOrderAwaitHost: buildTargetInfo.cloudFlareOrderAwaitHost,
  yUrl: buildTargetInfo.yUrl,
  yBearerToken: buildTargetInfo.yBearerToken,
  yLogUrl: buildTargetInfo.yLogUrl,
  yLogBearerToken: buildTargetInfo.yLogBearerToken,
  yogiyoUrl: buildTargetInfo.yogiyoUrl,
  yWebsockUrl: buildTargetInfo.yWebsockUrl,
  allServerIp: buildTargetInfo.allServerIp,

  //drnana
  // serverProtocol: 'https',
  // serverIp: 'drnana.nnbox.net',
  // wsProtocol: 'wss',
  // wsPath: '/ws/nnbox',
  // serverPort: "443",
  // cloudFlareOrderInfoHost:"frcust.nyamnyambox.com",
  // yUrl:"https://y.nyamnyambox.com",
  // yBearerToken:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC15YW5nIiwibmFtZSI6ImhlZXdvb2siLCJpYXQiOjE4OTM0MjM2MDB9.YJ6GRW6s1YjNSAXLtbOT3p8C21fjcIg1vYEjIK8cBeU",
  // yLogUrl:"https://nnbox-log.nyamnyambox.com",
  // yLogBearerToken:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJubmxvZyI6ImxpdmUifQ.bLr-YxVD2-M-TUblNmaUskKguyenW1WZpuSwtreKXGc",
  // yogiyoUrl:"https://crs.rpsyogiyo.io/api",
  // yWebsockUrl:"ps.rpsyogiyo.io",


  //aws01
  // serverProtocol: 'https',
  // serverIp: 'gp.back.nyamnyambox.com',
  // wsProtocol: 'wss',
  // cloudFlareOrderInfoHost:"frcust.nyamnyambox.com",
  // yUrl:"https://y.nyamnyambox.com",
  // yBearerToken:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJubmJveC15YW5nIiwibmFtZSI6ImhlZXdvb2siLCJpYXQiOjE4OTM0MjM2MDB9.YJ6GRW6s1YjNSAXLtbOT3p8C21fjcIg1vYEjIK8cBeU",
  // yLogUrl:"https://nnbox-log.nyamnyambox.com",
  // yLogBearerToken:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJubmxvZyI6ImxpdmUifQ.bLr-YxVD2-M-TUblNmaUskKguyenW1WZpuSwtreKXGc",
  // yogiyoUrl:"https://crs.rpsyogiyo.io/api",
  // yWebsockUrl:"ps.rpsyogiyo.io",


  // serverPort: "443",
  serverContext: '',

  maxMobileWidth: 999, // @media screen and (max-width: 999px)

  //time interval
  noticeInterval: 60000, // 공지사항
  notifyOrderInterval: 11333, // 배달현황 알림
  depositInterval: 60777, // 예치금
  deliveryInterval: 67533, // 배달정보
  addrBranchesInterval: 61733, // 배송가능지역 정보
  reconnectInterval: 69313, // chatting reconnect
  surchargeInterval: 67533, // 할증정보
  systemStatusTimeInterval: 600000, // 버전정보
  localStorageInterval: 75745,
  getFrIPInfoInterval: 3600000,

  remoteSupportUrl: 'https://www.988.co.kr/connect9',

  //배달의 민족 orderrelationapp const
  posOrderInterval: 4500,
  posOrderEnable: false,
  posOrderIp: '127.0.0.1',
  posOrderPort: 37001,

  //posorderelationapp const
  posOrderRelationAppInterval: 5000,
  posOrderRelationAppEnable: false,
  posOrderRelationAppPort: 37003,

  //cidrelationapp const
  cidIp: '127.0.0.1',
  cidRelationAppInterval: 3000,
  cidRelationAppEnable: false,
  cidPort: 37005,

  autoConfirmPickupTime: 15,

  websocketPingIntervalMS: 60000,

  orderListPollingTimeMS: 2000,
  orderAwaitListPollingTimeMS: 3000,
};
